import { render, staticRenderFns } from "./MainPanel.vue?vue&type=template&id=dc235662&scoped=true&"
import script from "./MainPanel.vue?vue&type=script&lang=js&"
export * from "./MainPanel.vue?vue&type=script&lang=js&"
import style0 from "./MainPanel.vue?vue&type=style&index=0&id=dc235662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc235662",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc235662')) {
      api.createRecord('dc235662', component.options)
    } else {
      api.reload('dc235662', component.options)
    }
    module.hot.accept("./MainPanel.vue?vue&type=template&id=dc235662&scoped=true&", function () {
      api.rerender('dc235662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/MainPanel.vue"
export default component.exports